import { useNavigate } from 'react-router-dom';

export default function Landing() {
  const navigate = useNavigate();

  const s: any = {
    section: { padding: '80px 24px', maxWidth: 1100, margin: '0 auto' },
    badge: { display: 'inline-block', background: '#00D4AA22', border: '1px solid #00D4AA55', borderRadius: 20, padding: '4px 14px', color: '#00D4AA', fontSize: 12, fontWeight: 600, marginBottom: 16 },
    btn: { background: '#00D4AA', border: 'none', borderRadius: 10, padding: '14px 36px', color: '#0A1F18', fontSize: 16, fontWeight: 700, cursor: 'pointer' },
    btnGhost: { background: 'none', border: '1px solid #2A3045', borderRadius: 10, padding: '14px 36px', color: '#E8ECF4', fontSize: 16, cursor: 'pointer' },
    card: { background: '#161B27', border: '0.5px solid #2A3045', borderRadius: 12, padding: 28 },
    featureIcon: { fontSize: 32, marginBottom: 12 },
  };

  const features = [
    { icon: '🛍', title: '네이버 쇼핑 순위 조회', desc: '내 상품이 몇 위인지 실시간으로 확인하세요. 키워드별 순위 변동을 자동으로 추적합니다.', keyword: '쇼핑 순위 자동 추적' },
    { icon: '🔍', title: '키워드 검색량 분석', desc: '최대 100개 키워드의 월간 검색량, 경쟁도, 클릭률을 한번에 조회합니다.', keyword: '최대 100개 동시 조회' },
    { icon: '📍', title: '네이버 플레이스 순위', desc: '내 가게가 어떤 키워드에서 몇 위인지 확인하고 경쟁사와 비교하세요.', keyword: '경쟁사 비교 분석' },
    { icon: '🔤', title: '형태소 분석기', desc: '상품명·리뷰·블로그 글을 분석해 핵심 키워드를 자동으로 추출합니다.', keyword: '핵심 키워드 자동 추출' },
    { icon: '🎯', title: '마케팅 전략 자동 생성', desc: '관여도 진단부터 채널 전략, 키워드 전략, 4주 액션 플랜까지 자동으로 생성합니다.', keyword: 'AI 마케팅 플랜' },
    { icon: '📊', title: '통합검색 분석', desc: '블로그·카페·지식iN에서 내 키워드가 얼마나 노출되는지 분석합니다.', keyword: '블로그·카페·지식iN' },
  ];

  const steps = [
    { num: '01', title: '회원가입', desc: '이메일로 30초만에 가입' },
    { num: '02', title: '상품/플레이스 등록', desc: 'URL 입력만으로 자동 등록' },
    { num: '03', title: '키워드 입력', desc: '조회할 키워드 입력' },
    { num: '04', title: '순위 확인', desc: '실시간 순위 및 변동 추적' },
  ];

  return (
    <div style={{ background: '#0F1117', minHeight: '100vh', color: '#E8ECF4' }}>
      {/* 네비게이션 */}
      <nav style={{ borderBottom: '0.5px solid #1E2535', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, background: '#0F1117', zIndex: 100 }}>
        <div style={{ color: '#00D4AA', fontSize: 20, fontWeight: 800 }}>SellerRanky</div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button style={{ ...s.btnGhost, padding: '6px 12px', fontSize: 13, whiteSpace: 'nowrap' as const }} onClick={() => navigate('/pricing')}>요금제</button>
          <button style={{ ...s.btnGhost, padding: '6px 12px', fontSize: 13, whiteSpace: 'nowrap' as const }} onClick={() => navigate('/login')}>로그인</button>
          <button style={{ ...s.btn, padding: '6px 12px', fontSize: 13, whiteSpace: 'nowrap' as const }} onClick={() => navigate('/dashboard')}>무료시작</button>
        </div>
      </nav>

      {/* 히어로 섹션 */}
      <div style={{ ...s.section, textAlign: 'center', paddingTop: 100, paddingBottom: 80 }}>
        <div style={s.badge}>🚀 결제 없이 무료로 시작 · 스마트스토어 판매자를 위한 데이터 분석 도구</div>
        <h1 style={{ fontSize: 48, fontWeight: 800, lineHeight: 1.2, marginBottom: 20, color: '#E8ECF4' }}>
          네이버 쇼핑 순위부터<br />
          <span style={{ color: '#00D4AA' }}>마케팅 전략까지</span> 한번에
        </h1>
        <p style={{ fontSize: 18, color: '#8892A4', marginBottom: 40, maxWidth: 600, margin: '0 auto 40px' }}>
          셀러랭키는 스마트스토어·플레이스 판매자가 데이터 기반으로 성장할 수 있도록<br />
          순위 조회, 키워드 분석, 마케팅 전략을 무료로 제공합니다.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button style={{ ...s.btn, fontSize: 16, padding: '16px 40px' }} onClick={() => navigate('/dashboard')}>
            무료로 시작하기 →
          </button>
          <button style={{ ...s.btnGhost, fontSize: 16, padding: '16px 40px' }} onClick={() => navigate('/dashboard')}>
            로그인
          </button>
        </div>
        <p style={{ color: '#4A5568', fontSize: 13, marginTop: 16 }}>결제 불필요 · 즉시 사용 가능 · 한도 초과 시 유료 플랜 선택</p>
      </div>

      {/* 주요 기능 */}
      <div style={{ ...s.section, paddingTop: 60 }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={s.badge}>주요 기능</div>
          <h2 style={{ fontSize: 32, fontWeight: 700, marginBottom: 12 }}>판매에 필요한 모든 데이터</h2>
          <p style={{ color: '#8892A4', fontSize: 15 }}>6가지 핵심 분석 도구로 경쟁에서 앞서나가세요</p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 20 }}>
          {features.map((f, i) => (
            <div key={i} style={s.card}>
              <div style={s.featureIcon}>{f.icon}</div>
              <h3 style={{ color: '#E8ECF4', fontSize: 16, fontWeight: 700, marginBottom: 8 }}>{f.title}</h3>
              <p style={{ color: '#8892A4', fontSize: 13, lineHeight: 1.6, marginBottom: 12 }}>{f.desc}</p>
              <span style={{ background: '#00D4AA11', border: '1px solid #00D4AA33', borderRadius: 6, padding: '3px 10px', color: '#00D4AA', fontSize: 11 }}>{f.keyword}</span>
            </div>
          ))}
        </div>
      </div>

      {/* 사용 방법 */}
      <div style={{ ...s.section, paddingTop: 60 }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={s.badge}>사용 방법</div>
          <h2 style={{ fontSize: 32, fontWeight: 700 }}>4단계로 시작하세요</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20 }}>
          {steps.map((step, i) => (
            <div key={i} style={{ ...s.card, textAlign: 'center' }}>
              <div style={{ color: '#00D4AA', fontSize: 36, fontWeight: 800, marginBottom: 12 }}>{step.num}</div>
              <h3 style={{ color: '#E8ECF4', fontSize: 16, fontWeight: 700, marginBottom: 8 }}>{step.title}</h3>
              <p style={{ color: '#8892A4', fontSize: 13 }}>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div style={{ ...s.section, textAlign: 'center', paddingTop: 60, paddingBottom: 100 }}>
        <div style={{ ...s.card, maxWidth: 600, margin: '0 auto', padding: '48px 40px' }}>
          <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 12 }}>지금 바로 시작하세요</h2>
          <div style={{ background: '#0F2A22', border: '1px solid #00D4AA44', borderRadius: 8, padding: '10px 20px', marginBottom: 16, display: 'inline-block' }}>
              <span style={{ color: '#00D4AA', fontSize: 14, fontWeight: 700 }}>✅ 모든 기능 무료 · 더 필요하면 월 13,900원부터</span>
            </div>
            <p style={{ color: '#8892A4', fontSize: 15, marginBottom: 28 }}>결제 없이 가입하고 모든 기능을 무료로 사용해보세요</p>
          <button style={{ ...s.btn, fontSize: 16, padding: '16px 48px' }} onClick={() => navigate('/dashboard')}>
            무료로 시작하기
          </button>
        </div>
      </div>

      {/* 푸터 */}
      <footer style={{ borderTop: '0.5px solid #1E2535', padding: '32px 24px', textAlign: 'center' }}>
        <div style={{ color: '#00D4AA', fontSize: 16, fontWeight: 700, marginBottom: 8 }}>SellerRanky</div>
        <p style={{ color: '#4A5568', fontSize: 12 }}>
          네이버 쇼핑 순위 조회 · 키워드 검색량 분석 · 플레이스 순위 · 형태소 분석기 · 마케팅 전략
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 8 }}>
          <a href="/privacy" style={{ color: '#4A5568', fontSize: 11, textDecoration: 'none' }}>개인정보처리방침</a>
          <span style={{ color: '#2A3045' }}>|</span>
          <a href="/terms" style={{ color: '#4A5568', fontSize: 11, textDecoration: 'none' }}>이용약관</a>
          <span style={{ color: '#2A3045' }}>|</span>
          <span style={{ color: '#4A5568', fontSize: 11 }}>© 2026 SellerRanky. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}
